export class WheelSlice {
    points: number
    value: WheelValues

    constructor(value: WheelValues, points?: number) {
        this.value = value
        if (value === WheelValues.ADDICTED) {
            this.points = -100
        } else {
            this.points = points
        }
    }
}

export enum WheelValues {
    NOT_ADDICTED,
    ADDICTED
}

export const spin1Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 35),
    new WheelSlice(WheelValues.NOT_ADDICTED, 30),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 35),
    new WheelSlice(WheelValues.NOT_ADDICTED, 30),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spin2Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 30),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 30),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spin3Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 25),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spin4Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 20),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spin5Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 15),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spin6Slices = [
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
    new WheelSlice(WheelValues.NOT_ADDICTED, 5),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.ADDICTED),
    new WheelSlice(WheelValues.NOT_ADDICTED, 10),
]

export const spinConfigs = [spin1Slices, spin2Slices, spin3Slices, spin4Slices, spin5Slices, spin6Slices]
